import styled from 'styled-components';
import { colors } from '@keen.io/colors';

export const Heading = styled.span`
  font-size: 16px;
  line-height: 19px;
  font-family: 'Gangster Grotesk Bold', sans-serif;
  color: ${colors.black[100]};
`;
